<template>
	<li v-editable="blok" class="flex gap-[40px] mb-2 typo-body-m md:leading-5">
		<span class="shrink-0 w-[50px]">{{ blok.quantity }}</span>
		<span class="flex-1 leading-4">{{ blok.name }}</span>
	</li>
</template>

<script setup lang="ts">
	import type {IngredientsListItemStoryblok} from '@/storyblok/types';

	interface Props {
		blok: IngredientsListItemStoryblok
	}

	defineProps<Props>();
</script>
